// File: app/javascript/packs/extension_reasons.js

document.addEventListener('turbolinks:load', () => {
  // Check if we're on the election extension show page
  const mainContent = document.getElementById('main-content');
  if (!mainContent) return;

  const orderId = mainContent.dataset.orderId;
  const electionExtensionId = mainContent.dataset.electionExtensionId;

  // Exit early if not on an election extension show page
  if (!orderId || !electionExtensionId) return;

  const addReasonBtn = document.getElementById('add-reason-btn');
  const reasonInput = document.getElementById('new-reason-input');
  const reasonsList = document.getElementById('reasons-list');
  const reasonError = document.getElementById('reason-error');
  const noReasonsMessage = document.getElementById('no-reasons-message');

  if (!addReasonBtn || !reasonInput || !reasonsList) return;

  // Get CSRF token for Rails
  function getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  // Hide the "no reasons" message if there are reasons
  function updateNoReasonsMessage() {
    const reasonItems = reasonsList.querySelectorAll('.reason-item');
    if (noReasonsMessage) {
      noReasonsMessage.style.display = reasonItems.length === 0 ? 'block' : 'none';
    }
  }

  // Add reason
  addReasonBtn.addEventListener('click', async () => {
    const reason = reasonInput.value.trim();

    if (!reason) {
      reasonError.textContent = 'Please enter a reason.';
      reasonError.classList.remove('hidden');
      return;
    }

    reasonError.classList.add('hidden');
    addReasonBtn.disabled = true;
    addReasonBtn.textContent = 'Adding...';

    try {
      const response = await fetch(`/v2/orders/${orderId}/election_extensions/${electionExtensionId}/extension_reasons`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          extension_reason: { reason: reason }
        })
      });

      if (response.ok) {
        const data = await response.json();

        // Remove "no reasons" message if it exists
        if (noReasonsMessage) {
          noReasonsMessage.style.display = 'none';
        }

        // Create new reason element
        const reasonItem = document.createElement('div');
        reasonItem.className = 'reason-item flex items-start justify-between p-4 bg-gray-50 rounded-lg border border-gray-200';
        reasonItem.dataset.reasonId = data.id;
        reasonItem.innerHTML = `
          <div class="flex-1">
            <p class="text-gray-800">${escapeHtml(data.reason)}</p>
            <p class="text-xs text-gray-500 mt-1">Added ${data.created_at}</p>
          </div>
          <button type="button"
                  class="delete-reason-btn ml-4 text-red-600 hover:text-red-800 font-medium text-sm"
                  data-reason-id="${data.id}">
            Remove
          </button>
        `;

        // Insert at the beginning of the list
        reasonsList.insertBefore(reasonItem, reasonsList.firstChild);

        // Clear input
        reasonInput.value = '';

        // Attach delete handler
        attachDeleteHandler(reasonItem.querySelector('.delete-reason-btn'));
      } else {
        const errorData = await response.json();
        reasonError.textContent = errorData.errors ? errorData.errors.join(', ') : 'Failed to add reason.';
        reasonError.classList.remove('hidden');
      }
    } catch (error) {
      reasonError.textContent = 'An error occurred. Please try again.';
      reasonError.classList.remove('hidden');
    } finally {
      addReasonBtn.disabled = false;
      addReasonBtn.textContent = 'Add Reason';
    }
  });

  // Delete reason handler
  function attachDeleteHandler(button) {
    button.addEventListener('click', async () => {
      const reasonId = button.dataset.reasonId;

      if (!confirm('Are you sure you want to remove this reason?')) {
        return;
      }

      button.disabled = true;
      button.textContent = 'Removing...';

      try {
        const response = await fetch(`/v2/orders/${orderId}/election_extensions/${electionExtensionId}/extension_reasons/${reasonId}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-Token': getCSRFToken(),
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          // Remove the reason item from DOM
          const reasonItem = button.closest('.reason-item');
          reasonItem.remove();

          // Update "no reasons" message
          updateNoReasonsMessage();
        } else {
          alert('Failed to remove reason. Please try again.');
          button.disabled = false;
          button.textContent = 'Remove';
        }
      } catch (error) {
        alert('An error occurred. Please try again.');
        button.disabled = false;
        button.textContent = 'Remove';
      }
    });
  }

  // Attach delete handlers to existing reason items
  document.querySelectorAll('.delete-reason-btn').forEach(attachDeleteHandler);

  // Allow Enter key to submit (with Shift+Enter for new line)
  reasonInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      addReasonBtn.click();
    }
  });

  // Helper function to escape HTML
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
});
